import getAssetPath from '$utils/getAssetPath';

export default {
    props: {

    },
    components: {},

    data() {
        return {

        }
    },

    computed: {
		currentLocation() {
			const { pathname, href, search } = window.location;
			
			return { pathname, href, search };
		},
    },

    methods: {
        getAssetPath,
        switchTab(close) {
            window.location.hash = '#heatmap'
            close()
            this.refreshHeatmapIfNeeded()
        },
        onHeatmapLinkClick(close) {
            close()
            this.refreshHeatmapIfNeeded()
        },
        refreshHeatmapIfNeeded() {
            const tryFetch = () => {
                const activitiesDM = this.$store.state.activitiesDM
                if (!activitiesDM?.pendingHeatmapRefresh) return true
                if (!activitiesDM.collection) return false

                this.$store.commit('activitiesDM/setPendingHeatmapRefresh', false)
                this.$store.dispatch('activitiesDM/fetchData')
                return true
            }

            this.$nextTick(() => {
                if (tryFetch()) return
                setTimeout(tryFetch, 100)
                setTimeout(tryFetch, 300)
            })
        },
    }
}